import styled, { css } from 'styled-components'

export const Container = styled.div<{ polaroid?: boolean }>`
  cursor: pointer;
  transition: transform 0.2s linear;
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) => {
    return (
      props.polaroid &&
      css`
        padding: 2rem 0;
      `
    )
  }}

  @media screen and (max-width: 767px) {
    width: 100%;
  }
`

interface ImageProps {
  polaroid?: boolean
  rotationDegrees?: number
}

export const Image = styled.img<ImageProps>`
  width: 10rem;
  height: auto;

  ${(props) => {
    return (
      !props.polaroid &&
      css`
        filter: brightness(100) invert(0.6);

        &:hover,
        .swiper-slide-thumb-active & {
          filter: none;
        }
      `
    )
  }}

  --rotation: ${(props) => props.rotationDegrees ?? '7'}deg;

  ${(props) => {
    return (
      props.polaroid &&
      css`
        width: 7rem;
        height: 7rem;
        box-sizing: content-box;
        object-fit: cover;
        background-color: #ffffff;
        padding: 3px 3px 15px 3px;
        transform: rotate(var(--rotation));
        transition: all 0.2s ease-in-out;
        opacity: 0.7;
        box-shadow: 2px 2px 15px rgb(0 0 0 / 10%);

        &:hover,
        .swiper-slide-thumb-active & {
          transform: rotate(var(--rotation)) scale(1.1);
          opacity: 1;
        }
      `
    )
  }};

  @media screen and (max-width: 767px) {
    width: 100%;
    max-width: ${(props) => (props.polaroid ? 45 : 75)}px;

    ${(props) => {
      return (
        props.polaroid &&
        css`
          height: 45px;
          padding-bottom: 1rem;
        `
      )
    }}
  }
`

export const ModelIconWrapper = styled.div`
  width: 6rem;
  height: 6rem;

  .text-fill {
    fill: ${({ theme }) => `${theme.colors.text.primary} !important`};
  }
  .text-stroke {
    stroke: ${({ theme }) => `${theme.colors.text.primary} !important`};
  }

  &:hover {
    .text-stroke {
      stroke: #1b5774 !important;
    }
    .text-fill {
      fill: #1b5774 !important;
    }
  }

  .text-stroke {
    .swiper-slide-thumb-active & {
      stroke: #1b5774 !important;
    }
  }

  .text-fill {
    .swiper-slide-thumb-active & {
      fill: #1b5774 !important;
    }
  }

  @media screen and (min-width: 768px) {
    width: 8rem;
    height: 8rem;
  }
`

export const BulletContainer = styled.div`
  cursor: pointer;
  border-radius: 50%;

  .swiper-slide-thumb-active & {
    border: 2px solid ${({ theme }) => theme.colors.primary};
  }
`
export const StyledBullet = styled.div`
  background-color: ${({ theme }) => theme.colors.primary};
  width: 1rem;
  height: 1rem;
  margin: 0.2rem;
  border-radius: 50%;
`

export const StyledBulletSquared = styled.div`
  background-color: rgba(245, 245, 245, 0.5);
  height: 0.35rem;
  cursor: pointer;

  .swiper-slide-thumb-active & {
    background-color: #f5f5f5;
  }
`
